// extracted by mini-css-extract-plugin
export var sectionParagraph = "SectionParagraph-module--section-paragraph--3pcrw";
export var sectionParagraphDark = "SectionParagraph-module--section-paragraph--dark--3zoeC";